<template>
  <div class="container">
    <div class="courses-pc">
      <el-row :gutter="24">
        <el-col :span="4">
          <ul class="subject-list">
            <li class="ul-title">学科分类</li>
            <li
              class="item"
              v-for="(item, index) in subjectList"
              :key="'subject' + index"
              :class="{ active: params.parentId === item.classifyId }"
              @click="changeClassify(item.classifyId)"
            >
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </el-col>
        <el-col :span="20">
          <div class="course-area">
            <div class="search-area">
              <div class="total">
                搜索到<span class="num"
                  >{{ total }}门<span v-if="params.key"
                    >“{{ params.key }}”</span
                  ></span
                >相关课程
              </div>
              <el-input
                placeholder="搜索"
                suffix-icon="iconfont iconsousuo"
                v-model="keyVaule"
                @input="changeKey"
              >
              </el-input>
            </div>
            <div class="course-list">
              <el-row :gutter="16">
                <el-col
                  :span="6"
                  v-for="(item, index) in courseList"
                  :key="'course_' + index"
                >
                  <div class="course" @click="goDetail(item.courseId)">
                    <el-image
                      class="cover"
                      fit="contain"
                      :src="item.coverUrl | setCourseCover"
                    >
                      <div slot="error" class="img-error">
                        <img :src="require('@/assets/images/whkcsz/default_img.png')" />
                      </div>
                    </el-image>
                    <div class="info-wrapper">
                      <div class="title">{{ item.courseName }}</div>
                      <div class="school">{{ item.schoolName }}</div>
                      <div class="info">
                        <span class="num"
                          >访问量：{{ item.viewCount | setViewCount }}</span
                        >
                        <span class="teachers">{{
                          item.teacherNames | formatTeachers
                        }}</span>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-pagination
                @current-change="changePageNum"
                :current-page.sync="pageNum"
                :page-size="params.ps"
                layout="prev, pager, next, jumper"
                :total="total"
                :hide-on-single-page="true"
              ></el-pagination>
            </div>
            <div class="no-data" v-if="!loading && courseList.length === 0">
              暂无符合条件的课程
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import util from "@/libs/util.js";
export default {
  name: "courses_pc",
  props: {
    subjectList: {
      type: Array,
      default() {
        return [];
      },
    },
    courseList: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pageNum: 1,
      keyVaule: "",
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.pageNum = this.params.pn;
      this.keyVaule = this.params.key;
    },
    changeKey() {
      this.$emit("changeKey", this.keyVaule);
    },
    changeClassify(classifyId) {
      this.$emit("changeClassify", classifyId);
    },
    changePageNum() {
      this.$emit("changePageNum", this.pageNum);
    },
    goDetail(id) {
      this.$router.push({
        path: `/whkcsz/courseDetail/${id}`,
      });
    },
  },
  filters: {
    setCourseCover(src) {
      return util.setCourseCover(src);
    },
    setViewCount(count) {
      return util.setViewCount(count);
    },
    formatTeachers(teacherNames) {
      if (!teacherNames) {
        return "";
      }
      let str = "";
      let list = JSON.parse(JSON.stringify(teacherNames));
      str = list.splice(0, 2).join(" ");
      if (teacherNames.length > 2) {
        str += " 等";
      }
      return str;
    },
  },
  watch: {
    params: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../variables.scss";
.courses-pc {
  margin: 30px 0 0;
  color: #444444;
  .subject-list {
    margin: 0 0 80px;
    padding: 0 0 10px;
    background-color: #ffffff;
    border: 1px solid #dddddd;
    list-style: none;
    .ul-title {
      margin: -1px -1px 10px;
      height: 42px;
      padding-left: 20px;
      line-height: 42px;
      background-color: $primary-color;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
    }
    .item {
      height: 48px;
      padding-left: 20px;
      line-height: 48px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        background-color: #f5f5f5;
      }
      &.active {
        position: relative;
        color: $primary-color;
        &::before {
          content: " ";
          display: block;
          position: absolute;
          left: 0;
          top: 12px;
          width: 3px;
          height: 24px;
          background-color: $primary-color;
        }
      }
    }
  }
  .course-area {
    margin-bottom: 80px;
    .search-area {
      position: relative;
      margin-bottom: 24px;
      height: 32px;
      .total {
        font-size: 16px;
        color: #888888;
        line-height: 32px;
        .num {
          margin: 0 4px;
          color: #444444;
        }
      }
      .el-input {
        position: absolute;
        right: 0;
        top: 0;
        width: 200px;
        /deep/.el-input__inner {
          height: 32px !important;
          padding: 6px 30px 6px 12px;
          line-height: 20px !important;
          background-color: #f5f5f5 !important;
          border-radius: 20px;
          border: none;
          &:focus {
            background-color: #f5f5f5 !important;
          }
        }
        /deep/.el-input__suffix {
          cursor: pointer;
          right: 12px;
          .el-input__icon {
            font-size: 18px;
            color: #969696;
            line-height: 32px;
          }
        }
      }
    }
    .course-list {
      .course {
        position: relative;
        margin-bottom: 30px;
        padding-top: 56.25%;
        background-color: #f5f5f5;
        cursor: pointer;
        transition: 0.3s;
        .el-image {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 102px;
        }
        .info-wrapper {
          padding: 10px 10px 16px;
          .title {
            margin-bottom: 8px;
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
            @include ellipsis-one(100%);
          }
          .school {
            margin-bottom: 8px;
            font-size: 12px;
            font-weight: bold;
            line-height: 18px;
            @include ellipsis-one(100%);
          }
          .info {
            position: relative;
            font-size: 12px;
            color: #888888;
            line-height: 18px;
            .num {
              margin-right: 10px;
            }
            .teachers {
              position: absolute;
              right: 0;
              top: 0;
              @include ellipsis-one(calc(100% - 98px));
            }
          }
        }
        &:hover {
          -webkit-transform: scale(1.04);
          -moz-transform: scale(1.04);
          -ms-transform: scale(1.04);
          transform: scale(1.04);
          box-shadow: 0 2px 15px 0 rgba(215, 215, 215, 0.8);
          .title {
            color: $primary-color;
          }
        }
      }
    }
    .no-data {
      margin-top: 100px;
      font-size: 16px;
      color: #969696;
      text-align: center;
      line-height: 24px;
    }
  }
}
</style>